import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import NeedHelpFooter from './NeedHelpFooter';

const catIDs = {
  EDUCATION_BENEFITS: '75524deb-d864-eb11-bb24-000d3a579c45',
  BENEFITS_ISSUES: '66524deb-d864-eb11-bb24-000d3a579c45',
};

const topicIDs = {
  VETERAN_READINESS: 'b18831a7-8276-ef11-a671-001dd8097cca',
  EDUCATION_BENEFITS: 'bf2a8586-e764-eb11-bb23-000d3a579c3f',
};

const isEducationRelated = (cat, topic) =>
  (cat === catIDs.EDUCATION_BENEFITS && topic !== topicIDs.VETERAN_READINESS) ||
  (cat === catIDs.BENEFITS_ISSUES && topic === topicIDs.EDUCATION_BENEFITS);

export default function Footer({ currentLocation }) {
  const { pathname } = currentLocation;
  const { categoryId, topicId } = useSelector(state => state.form.data);

  const showEducation =
    !['/select-category', '/select-topic'].includes(pathname) &&
    isEducationRelated(categoryId, topicId);

  return (
    <div className="vads-u-margin-bottom--2 vads-u-margin-top--4">
      <div className="row">
        <div className="usa-width-two-thirds medium-8 columns">
          <NeedHelpFooter isEducationRelated={showEducation} />
        </div>
      </div>
      <div className="row">
        <va-back-to-top />
      </div>
    </div>
  );
}

Footer.propTypes = {
  currentLocation: PropTypes.object,
};
